// extracted by mini-css-extract-plugin
module.exports = {"primary":"LinkButton_primary___HO1d","secondary":"LinkButton_secondary__SvyE_","ghost":"LinkButton_ghost__7LZpn","disabled":"LinkButton_disabled__msCpF"};